import { GET_USERS, IS_LOADING_GET_USERS, IS_LOADING_SEARCH,GLOBAL_SEARCH, SEARCH_FRIENDS, IS_LOADING_SEARCH_FRIENDS } from '../actions/types'

const initialState = {
    fileLoadingState: false,
    usersList: null,
    isLoadingUsers: true,
    friendSearchList: [],
    isLoadingSearchFriendList: true,
    searchList: {},
    isLoadingSearchList: true,
}

export default function (state = initialState, action) {

    switch (action.type) { //que me llega la cadena type para el switch y el payload en este caso 
        case GET_USERS:
            console.log()
            return { ...state, usersList: action.payload, isLoadingUsers: false }
        case IS_LOADING_GET_USERS:
            return { ...state, isLoadingUsers: true }
        case GLOBAL_SEARCH:
            return { ...state, searchList: action.payload, isLoadingSearchList: false }
        case IS_LOADING_SEARCH:
            return { ...state, isLoadingSearchList: true }
        case IS_LOADING_SEARCH_FRIENDS:
            return { ...state, isLoadingSearchFriendList: true }
        case SEARCH_FRIENDS:
            return { ...state, friendSearchList: action.payload, isLoadingSearchFriendList: false }
        default:
            return state
    }
}